/* eslint-disable import/prefer-default-export */
import axios from '../../utils/axios';
import { BAD_REQUEST, INTERNAL_SERVER_ERROR } from '../../utils/const/http';

const getTaskResponses = async (
  page,
  limit,
  companyId,
  id,
  surveyTitle,
  location,
  email,
  dateStart,
  dateEnd,
  state,
) => {
  try {
    const params = new URLSearchParams();
    params.append('companyId', companyId);
    params.append('page', page);
    params.append('limit', limit);
    params.append('id', id);
    params.append('surveyTitle', surveyTitle);
    params.append('location', location);
    params.append('email', email);
    params.append('dateStart', dateStart);
    params.append('dateEnd', dateEnd);
    params.append('state', state);

    const url = `/api/task-responses/?${params.toString()}`;
    const { data } = await axios.get(url);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getAllTaskResponsesPerPage = async (page, limit, filters, order = {}) => {
  try {
    const params = new URLSearchParams({
      page,
      limit,
      ...(filters.id?.trim() && { id: filters.id }),
      ...(filters.branch?.trim() && { branch: filters.branch }),
      ...(filters.survey?.trim() && { survey: filters.survey }),
      ...(filters.dateStart?.trim() && { dateStart: filters.dateStart }),
      ...(filters.dateEnd?.trim() && { dateEnd: filters.dateEnd }),
      ...(filters.user?.trim() && { user: filters.user }),
      ...(order.sortBy && { sortBy: order.sortBy }),
      ...(order.sortOrder && { sortOrder: order.sortOrder }),
    });

    const { data } = await axios.get(`/api/task-responses-all?${params.toString()}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage
      : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};
// const startTaskResponseReview = async (taskResponseId) => {
//   try {
//     const { data } = await axios.post(`/api/task-responses/${taskResponseId}/start-review`);
//     return {
//       success: data.success,
//       status: data.status,
//       message: data.message,
//       data,
//     };
//   } catch (err) {
//     // TODO: need better handle of response in CONFLICT state
//     let taskResponseReview = '';
//     if (err.response.status === CONFLICT) {
//       taskResponseReview = err.response ? err.response.data.data.taskResponseReview : {};
//     }

//     const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
//     const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
//     const errorMessage = (err.response && err.response.data && err.response.data.data)
//       ? err.response.data.data.errorMessage :
// 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

//     return {
//       success: false,
//       status,
//       message,
//       data: {
//         errorMessage,
//         taskResponseReview,
//       },
//     };
//   }
// };

// Resultado fallido de un export. Con responseType 'blob' el body de error también llega
// como Blob; en los 400 (p. ej. máximo de filas superado) se recupera el mensaje.
const getExportErrorResult = async (err) => {
  const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;

  let errorMessage = null;
  if (status === BAD_REQUEST.status && err.response.data instanceof Blob) {
    try {
      const body = JSON.parse(await err.response.data.text());
      errorMessage = body?.data?.errorMessage || null;
    } catch (parseError) {
      errorMessage = null;
    }
  }

  return {
    success: false,
    status,
    errorMessage,
  };
};

// Exportar información de un proyecto
const exportTaskResponses = async (filters = {}) => {
  try {
    const params = new URLSearchParams({
      ...(filters.id?.trim() && { id: filters.id }),
      ...(filters.branch?.trim() && { branch: filters.branch }),
      ...(filters.survey?.trim() && { survey: filters.survey }),
      ...(filters.user?.trim() && { user: filters.user }),
      ...(filters.dateStart?.trim() && { dateStart: filters.dateStart }),
      ...(filters.dateEnd?.trim() && { dateEnd: filters.dateEnd }),
    });

    const { data } = await axios.get(`/api/task-responses/export?${params.toString()}`, {
      responseType: 'blob', // necesario para descargar archivos
    });

    return {
      success: true,
      data,
    };
  } catch (err) {
    return getExportErrorResult(err);
  }
};

// Reporte de auditoría: una fila por respuesta, con los mismos filtros de la tabla
const exportTaskResponsesAuditReport = async (filters = {}) => {
  try {
    const params = new URLSearchParams({
      ...(filters.id?.trim() && { id: filters.id }),
      ...(filters.branch?.trim() && { branch: filters.branch }),
      ...(filters.survey?.trim() && { survey: filters.survey }),
      ...(filters.user?.trim() && { user: filters.user }),
      ...(filters.dateStart?.trim() && { dateStart: filters.dateStart }),
      ...(filters.dateEnd?.trim() && { dateEnd: filters.dateEnd }),
    });

    const { data } = await axios.get(`/api/task-responses/audit-report?${params.toString()}`, {
      responseType: 'blob',
    });

    return {
      success: true,
      data,
    };
  } catch (err) {
    return getExportErrorResult(err);
  }
};

const updateDeletedSurveyResponses = async (id, deleted) => {
  try {
    const { data } = await axios.patch(`/api/task-responses/${id}/deleted`, { deleted });
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage
      : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: { errorMessage },
    };
  }
};

export {
  getTaskResponses,
  getAllTaskResponsesPerPage,
  // startTaskResponseReview,
  exportTaskResponses,
  exportTaskResponsesAuditReport,
  updateDeletedSurveyResponses,
};
